var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../I18N";
import Modal from "./Modal";

class ConfirmModal extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx(Modal, { isOpen: this.props.isOpen, type: this.props.type }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, this.props.title)), /*#__PURE__*/

      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, this.props.message))), /*#__PURE__*/



      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default cancel-button",
        onClick: this.props.onCancel }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")), /*#__PURE__*/

      _jsx("button", {
        type: "button",
        className: `btn confirm-button btn-${this.props.type}`,
        onClick: this.props.onAccept }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Accept")))));




  }
}

ConfirmModal.defaultProps = {
  isOpen: true,
  message: 'Are you sure you want to continue?',
  title: 'Confirm action',
  type: 'danger'
};










export default ConfirmModal;